<footer  [ngClass]="{'transparent-footer': transparent(), 'footer' : !transparent()}">
  <mat-divider></mat-divider>
  <div class="footer-content">
    <div class="footer-text">
      {{ 'footer.need-help' | translate }}
      <a href="#" (click)="openModal($event)" class="footer-link link">{{ 'footer.fill-form' | translate }}</a>
    </div>
    <div class="footer-links">
      @if(!this.authService.isNotBinded()){
        <a href="#" class="footer-link link" (click)="navigateToOrderContactClick($event)">{{ 'footer.order-phone-contact' | translate }}</a>
      }
      <span class="footer-text"> {{ 'footer.or-call-number' | translate }} <a class="footer-link link footer-phone" href="tel:+48224444777">+48 22 4444 777</a></span>
    </div>
    <div class="footer-text">
      {{ 'footer.faq-first-part' | translate }}
      <a href="https://asseta.pl/pytania-i-odpowiedzi/" class="footer-link link">{{ 'footer.faq-bolted' | translate }}</a>
    </div>
  </div>
</footer>